import DetailsRow from "./DetailsRow";
import LeaveNameCellRenderer from "../renderers/LeaveNameCellRenderer";
import LeaveTimeCellRenderer from "../renderers/LeaveTimeCellRenderer";

export default class UserLeavesRow extends DetailsRow {
    createRowHeaderRenderer()
    {
        return new LeaveNameCellRenderer();
    }

    createLockCellRenderer()
    {
        return new LeaveTimeCellRenderer("odd DayDetailsCell",
            this.isFirstChildRow() ? "detailsRowSeparator" : "leaveDetailsCellTopBorder");
    }

    addValueToCell(colIdx, leaveInfoWithTime)
    {
        var cell = this.getCell(colIdx);
        if (!cell)
            this.addCell(leaveInfoWithTime);
        else if (leaveInfoWithTime.time > 0)
        {
            cell.setValue(leaveInfoWithTime);
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/rows/UserLeavesRow.js